import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["href", "title"]
const _hoisted_2 = { key: 1 }

import {__} from "~/ts/library/Translate";
import ClientInfoRefererTooltip
    from "~/operatorApplication/vue/dialogs/dialog/sidemenu/info/ClientInfoRefererTooltip.vue";


const __default__ = {
    name: "ClientInfoReferer"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    value: {},
    label: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _directive_my_tooltip = _resolveDirective("my-tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives((_openBlock(), _createElementBlock("span", null, [
      (__props.value)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            target: "_blank",
            href: __props.value,
            title: __props.value
          }, _toDisplayString(__props.value), 9, _hoisted_1))
        : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(__)("Прямой переход")), 1))
    ])), [
      [_directive_my_tooltip, typeof __props.label == 'string' ? {component: ClientInfoRefererTooltip, props: {label: __props.label,value: __props.value}} : null]
    ])
  ]))
}
}

})